import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { DocumentsProvider as Provider } from '@shapeable/ui';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const DOCUMENTS_QUERY = graphql`
query NodeAllDocumentsQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "Documents" } }) {
    nodes {
      data
    }
  }
}
`;

export const DocumentsProvider: React.FC<any> = ({ children }) => {
  return <Provider value={shapeableProviderValue(useStaticQuery(DOCUMENTS_QUERY), 'items')}>{children}</Provider>;
};
